import { getAcceptedFilesList, kAcceptedFilesList } from '@/constants/constants-gcs'

const acceptedExtensionsLower = new Set(
  Object.values(kAcceptedFilesList)
    .flat()
    .map((ext) => ext.toLowerCase())
)
const acceptedDetectedExtensionsLower = new Set([...acceptedExtensionsLower, '.eml', '.msg'])

/**
 * Whether an already imported file's detected format can be selected as a user file.
 * This is independent of the current upload-picker rollout flag.
 */
export function isDetectedExtensionAcceptedForUserFilesUpload(detectedExtension: string | null | undefined): boolean {
  const normalizedExtension = detectedExtension?.trim().toLowerCase().replace(/^\.+/, '')
  return normalizedExtension ? acceptedDetectedExtensionsLower.has(`.${normalizedExtension}`) : false
}

/**
 * Whether a local `File` may be uploaded to user-files / Drive (matches the Files dropzone).
 * Allowed extensions take precedence; MIME also covers extensionless downloads. Email filenames
 * require email processing even if the OS reports an otherwise accepted MIME type.
 */
export function isFileAcceptedForUserFilesUpload(file: File, emailFileProcessingEnabled = false): boolean {
  const acceptedFiles = getAcceptedFilesList(emailFileProcessingEnabled)
  // Determine based on extension
  const name = file.name
  const dot = name.lastIndexOf('.')
  if (dot >= 0 && dot < name.length - 1) {
    const ext = name.slice(dot).toLowerCase()
    if (
      Object.values(acceptedFiles)
        .flat()
        .some((acceptedExtension) => acceptedExtension.toLowerCase() === ext)
    )
      return true
    if (ext === '.eml' || ext === '.msg') return false
  }

  // Determine based on MIME type
  const type = file.type
  if (type && Object.hasOwn(acceptedFiles, type)) return true
  return false
}
